import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { buildComponentName } from '../utils';
import Icon from '../icon';
export default {
  $_veeValidate: {
    value: function value() {
      return this.getValue();
    }
  },
  name: buildComponentName('Input'),
  inheritAttrs: false,
  props: {
    prefixCls: {
      type: String,
      default: 'ux-input'
    },
    affixClass: {
      type: [String, Object, Array],
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    size: {
      type: String,
      default: 'default',
      validator: function validator(val) {
        return ['small', 'default', 'large', ''].indexOf(val) > -1;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    addonBefore: {
      type: String,
      default: ''
    },
    addonAfter: {
      type: String,
      default: ''
    },
    showWordLimit: {
      type: Boolean,
      default: false
    },
    allowClear: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      innerValue: '',
      length: 0
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          size = this.size,
          disabled = this.disabled;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(size === 'large' ? 'lg' : 'sm'), size === 'large' || size === 'small'), _defineProperty(_ref, "".concat(prefixCls, "-disabled"), disabled), _ref;
    },
    bindAttrs: function bindAttrs() {
      var $attrs = this.$attrs,
          disabled = this.disabled;
      return _objectSpread({}, $attrs, {
        disabled: disabled
      });
    },
    limitWord: function limitWord() {
      var length = this.length,
          showWordLimit = this.showWordLimit,
          $attrs = this.$attrs;
      var maxlength = $attrs.maxlength;
      return maxlength && showWordLimit ? "".concat(length, "/").concat(maxlength) : null;
    }
  },
  watch: {
    value: function value(nVal) {
      this.setValue(nVal);
    }
  },
  created: function created() {
    this.setValue(this.value);
  },
  methods: {
    setValue: function setValue(val) {
      this.innerValue = val;
      this.length = val ? val.length : 0;
    },
    getValue: function getValue() {
      return this.innerValue;
    },
    onInput: function onInput(e) {
      var val = e.target.value;
      this.setValue(val);
      this.$emit('input', val, e);
    },
    onKeydown: function onKeydown(e) {
      if (e.keyCode === 13) {
        this.$emit('pressenter', e);
      }

      this.$emit('keydown', e);
    },
    // http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/230
    onBlur: function onBlur(e) {
      this.$emit('blur', e);
    },
    focus: function focus() {
      var inputRef = this.$refs.inputRef;

      if (inputRef) {
        inputRef.focus();
      }
    },
    blur: function blur() {
      var inputRef = this.$refs.inputRef;

      if (inputRef) {
        inputRef.blur();
      }
    },
    getInputElement: function getInputElement() {
      return this.$refs.inputRef;
    },
    getSlotOrAttrVal: function getSlotOrAttrVal(name) {
      var $slots = this.$slots;
      var slotVal = $slots[name];

      if (slotVal) {
        return slotVal;
      }

      var attrVal = this[name];

      if (attrVal) {
        return attrVal;
      }

      return null;
    },
    onClear: function onClear(e) {
      this.setValue('');
      this.focus();
      this.$emit('input', '', e);
    },
    renderClearIcon: function renderClearIcon() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          allowClear = this.allowClear,
          innerValue = this.innerValue,
          onClear = this.onClear;

      if (!allowClear || innerValue === undefined || innerValue === null || innerValue === '') {
        return null;
      }

      return h(Icon, {
        "attrs": {
          "type": "close_circle",
          "role": "button"
        },
        "class": "".concat(prefixCls, "-clear-icon"),
        "on": {
          "click": onClear
        }
      });
    },
    renderInput: function renderInput() {
      var _ref2;

      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          classes = this.classes,
          $listeners = this.$listeners,
          bindAttrs = this.bindAttrs,
          innerValue = this.innerValue,
          onInput = this.onInput,
          onKeydown = this.onKeydown,
          onBlur = this.onBlur,
          affixClass = this.affixClass,
          size = this.size,
          getSlotOrAttrVal = this.getSlotOrAttrVal,
          limitWord = this.limitWord,
          allowClear = this.allowClear,
          renderClearIcon = this.renderClearIcon;
      var prefix = getSlotOrAttrVal('prefix');
      var suffix = getSlotOrAttrVal('suffix');

      var on = _objectSpread({}, $listeners, {
        input: onInput,
        keydown: onKeydown,
        // http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/230
        blur: onBlur
      });

      var inputElement = h("input", _mergeJSXProps([{}, {
        class: !prefix && !suffix ? [classes, affixClass] : classes,
        attrs: bindAttrs,
        domProps: {
          value: innerValue
        },
        on: on,
        ref: 'inputRef'
      }]));

      if (!prefix && !suffix && !limitWord && !allowClear) {
        return inputElement;
      }

      var prefixElement = prefix ? h("span", {
        "class": "".concat(prefixCls, "-prefix")
      }, [prefix]) : null;
      var limitWordElement = limitWord ? h("span", {
        "class": "".concat(prefixCls, "-limit-word")
      }, [limitWord]) : null;
      var suffixElement = suffix || limitWordElement || allowClear ? h("span", {
        "class": "".concat(prefixCls, "-suffix")
      }, [renderClearIcon(), suffix, limitWordElement]) : null;
      var affixCls = [affixClass, (_ref2 = {}, _defineProperty(_ref2, "".concat(prefixCls, "-affix-wrapper"), true), _defineProperty(_ref2, "".concat(prefixCls, "-affix-wrapper-").concat(size === 'large' ? 'lg' : 'sm'), size === 'large' || size === 'small'), _ref2)];
      return h("span", {
        "class": affixCls
      }, [prefixElement, inputElement, suffixElement]);
    },
    renderAddon: function renderAddon(children) {
      var _wrapperCls, _groupCls;

      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          size = this.size,
          getSlotOrAttrVal = this.getSlotOrAttrVal;
      var addonBefore = getSlotOrAttrVal('addonBefore');
      var addonAfter = getSlotOrAttrVal('addonAfter');

      if (!addonBefore && !addonAfter) {
        return children;
      }

      var addonCls = "".concat(prefixCls, "-group-addon");
      var before = addonBefore ? h("span", {
        "class": addonCls
      }, [addonBefore]) : null;
      var after = addonAfter ? h("span", {
        "class": addonCls
      }, [addonAfter]) : null;
      var wrapperCls = (_wrapperCls = {}, _defineProperty(_wrapperCls, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_wrapperCls, "".concat(prefixCls, "-group"), true), _wrapperCls);
      var groupCls = (_groupCls = {}, _defineProperty(_groupCls, "".concat(prefixCls, "-group-wrapper"), true), _defineProperty(_groupCls, "".concat(prefixCls, "-group-wrapper-").concat(size === 'large' ? 'lg' : 'sm'), size === 'large' || size === 'small'), _groupCls);
      return h("span", {
        "class": groupCls
      }, [h("span", {
        "class": wrapperCls
      }, [before, children, after])]);
    }
  },
  render: function render() {
    var renderAddon = this.renderAddon,
        renderInput = this.renderInput;
    return renderAddon(renderInput());
  }
};